import React, { Component } from "react";
import { connect } from "react-redux";
import {
	Dropdown,
	OverlayTrigger,
	Tooltip,
} from "react-bootstrap";
import moment from "moment";
import Moment from "react-moment";
import { toastr } from "react-redux-toastr";
import {
	FiArrowLeft,
	FiMoreHorizontal,
	FiChevronLeft,
	FiChevronRight,
	FiPlus,
} from "react-icons/fi";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { FaRegComment, FaHome, FaKeyboard, FaGlobe } from "react-icons/fa";
import { BsCreditCard2Front } from "react-icons/bs";
import { MobileOrTablet } from "utils/responsive";
import { isSafari, deviceType, browserName, osName } from "react-device-detect";
import TimeInputWithArrows from "components/TimeInputWithArrows";
import * as employeesActions from "actions/employeesActions";
import * as timesActions from "actions/timesActions";
import {
	timesService,
	plansService,
	calendarsService,
	timeTypesService,
	transactionsService,
	accountsService,
	employeesService,
} from "services";
import { shiftType } from "services/shiftsService";
import {
	getDiffTime,
	formatMinutesToTime,
	formatSecondsToTime,
	getWorkedTime,
	getWorkedTimeRaw,
	getBalanceHours,
	convertFromUTC,
} from "utils/datetime";
import { isAdmin, isSupervisor, getContrastColor } from "utils/utils";
import { createApprovalLock } from "utils/approvalInFlight";
import Layout from "components/Layout";
import Loading from "components/Loading";
import Switch from "components/Switch";
import SwitchCompact from "components/SwitchCompact";
import Modal from "components/Modal";
import TimesNavigationTabs from "components/Times/TimesNavigationTabs";
import TimeObservationEdit from "components/TimeRegistrations/TimeObservationEditModal";
import TimeRegistrationLogModal from "components/TimeRegistrations/TimeRegistrationLogModal";
import TimeRegistrationDayTag from "components/TimeRegistrations/TimeRegistrationDayTag";
import TimeRegistrationAddTimeButton from "components/TimeRegistrations/TimeRegistrationAddTimeButton";
import TimeRegistrationTypeSelect from "components/TimeRegistrations/TimeRegistrationTypeSelect";
import TimeRegistrationUbicationSelect from "components/TimeRegistrations/TimeRegistrationUbicationSelect";
import {
	defaultUbicationId,
	resolveUbicationId,
	toSelectOptions,
	withUbicationId,
} from "components/TimeRegistrations/timeRegistrationUbication";
import TimeRegistrationsMonthSummary from "components/TimeRegistrations/TimeRegistrationsMonthSummary";
import TimeRegistrationDayCard from "components/TimeRegistrations/TimeRegistrationDayCard";
import TimeRegistrationShiftTag from "components/TimeRegistrations/TimeRegistrationShiftTag";
import ShiftPreviewTooltip from "components/Shifts/ShiftPreviewTooltip";
import { showModal, hideModal } from "actions/modalActions";
import { getEmployeeTimeTypes } from "components/TimeTypes/utils";
import HelpBanner from "components/HelpBanner";
import DataTable from "components/DataTable";
import {
	trackHaddockEvent,
	getApprovalActorProps,
} from "utils/posthogTracking";
import {
	hasTimeChat,
	hasTimeChatOrAttachments,
	isTempTimeRegistration,
} from "utils/timeChatUtils";
import { withTranslation } from "react-i18next";

/**
 * Respuesta de `plans/assignments/planned-hours` tras `handleResponse`: a veces
 * viene como array, a veces como `{ data: [...] }` (como las transacciones).
 * No se calcula en cliente a partir de la columna Turnos.
 */
function normalizePlannedHoursList(response) {
	if (!response || response.ok === false) return [];
	if (Array.isArray(response)) return response;
	if (Array.isArray(response.data)) return response.data;
	if (Array.isArray(response.results)) return response.results;
	return [];
}

class TimeRegistrations extends Component {
	constructor(props) {
		super(props);
		const userId = props.user.id;
		let employee_id = userId;
		let isMe = true;

		if (this.props.match.params.id !== undefined) {
			employee_id = parseInt(this.props.match.params.id);
			isMe = userId === employee_id;
		}

		const today = new Date();
		const dayParam = new URLSearchParams(props.location?.search || "").get("day");
		const dayMoment = dayParam ? moment(dayParam, "YYYY-MM-DD", true) : null;
		const current = dayMoment?.isValid() ? dayMoment.toDate() : today;
		this.state = {
			employee_id,
			isMe: isMe,
			times: [],
			prevTimes: [],
			current,
			isCurrentMonth: moment(current).isSame(today, "month"),
			loading: true,
			plan_assignments: [],
			objective_hours: [],
			planned_hours: [],
			employee_calendars: [],
			isEmployeeActive: true,
			allow_manual_time_registrations:
				props.user.employee_with_contract &&
				props.user.employee_with_contract.contract
					? props.user.employee_with_contract.contract
							.allow_manual_time_registrations
					: true,
			pendingOperations: 0,
			approvingDayKeys: {},
			employee_ubications_list: [],
			useDesktopDataTable:
				typeof window !== "undefined" &&
				window.matchMedia("(min-width: 992px)").matches,
		};
		this.pendingOperationsCount = 0;
		this.approvalLock = createApprovalLock();

		this.myRef = React.createRef();
		this.closeModal = this.closeModal.bind(this);
		this.openDeleteModal = this.openDeleteModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.openObservationsModal = this.openObservationsModal.bind(this);
		this.openLogsModal = this.openLogsModal.bind(this);
		this.getTimeList = this.getTimeList.bind(this);
		this.getAssignmentsList = this.getAssignmentsList.bind(this);
		this.getCalendarList = this.getCalendarList.bind(this);
	}

	async componentDidMount() {
		if (!this.state.isMe) {
			this.props.getEmployee(this.state.employee_id);
		}
		this.props.getSelectableTimeTypes();
		this.props.getDefaultTimeType();
		await this.getEmployeeTimeTypeList();
		await this.loadEmployeeUbications();
		this.getTimeList();
		this.getAssignmentsList();
		this.getCalendarList();
		this.getObjectiveHoursList();

		this._desktopMql = window.matchMedia("(min-width: 992px)");
		this._onDesktopMql = () => {
			this.setState({ useDesktopDataTable: this._desktopMql.matches });
		};
		if (this._desktopMql.addEventListener) {
			this._desktopMql.addEventListener("change", this._onDesktopMql);
		} else {
			this._desktopMql.addListener(this._onDesktopMql);
		}
	}

	componentWillUnmount() {
		if (this._desktopMql && this._onDesktopMql) {
			if (this._desktopMql.removeEventListener) {
				this._desktopMql.removeEventListener("change", this._onDesktopMql);
			} else {
				this._desktopMql.removeListener(this._onDesktopMql);
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.employee !== this.props.employee && this.props.employee) {
			this.setState({ isEmployeeActive: this.props.employee.enabled });
		}
		if (
			prevState.loading &&
			!this.state.loading &&
			this.state.isCurrentMonth &&
			this.state.useDesktopDataTable
		) {
			const tr = document.querySelector(
				".page-time-registrations tr.time-registrations-today-row"
			);
			if (tr) {
				tr.scrollIntoView({ block: "start", behavior: "smooth" });
			}
		}
	}

	getEmployeeTimeTypeList = async () => {
		const { user } = this.props;
		const { isMe, employee_id } = this.state;

		var employee_time_types_list = [];

		if (isMe && user.employee_with_time_types) {
			employee_time_types_list = user.employee_with_time_types;
		} else {
			var response = await timeTypesService.getContractTimeTypes({
				employee_id,
			});
			employee_time_types_list = response.ok ? response : [];
		}

		this.setState({
			employee_time_types_list,
		});
	};

	loadEmployeeUbications = async () => {
		const { employee_id } = this.state;
		const response = await employeesService.getUbications(employee_id);
		this.setState({
			employee_ubications_list: response.ok ? response : [],
		});
	};

	getUbicationOptionsList = () => {
		const { employee_ubications_list } = this.state;
		return toSelectOptions(employee_ubications_list, []);
	};

	applyDefaultUbicationToRow = (row) => {
		const options = this.getUbicationOptionsList();
		const defaultId = defaultUbicationId(options, null);
		if (defaultId > 0) {
			const opt = options.find((o) => o.id === defaultId);
			if (opt) {
				row.ubication = { id: opt.id, name: opt.name };
				row.ubication_id = opt.id;
			}
		}
		return row;
	};

	getUbicationSelectValue = (time) => {
		if (time.ubication && time.ubication.id != null) {
			return time.ubication.id;
		}
		if (time.ubication_id != null && time.ubication_id > 0) {
			return time.ubication_id;
		}
		return -1;
	};

	incrementPendingOperations = () => {
		this.pendingOperationsCount += 1;
		this.setState({ pendingOperations: this.pendingOperationsCount });
	};

	decrementPendingOperations = () => {
		this.pendingOperationsCount = Math.max(0, this.pendingOperationsCount - 1);
		this.setState({ pendingOperations: this.pendingOperationsCount });
	};

	markDayApproving = (dayKey, on) => {
		this.setState((prevState) => {
			const approvingDayKeys = { ...prevState.approvingDayKeys };
			if (on) approvingDayKeys[dayKey] = true;
			else delete approvingDayKeys[dayKey];
			return { approvingDayKeys };
		});
	};

	isDayApprovalInFlight = (time) => {
		const dayKey = moment(time.day).format("YYYY-MM-DD");
		return Boolean(this.state.approvingDayKeys[dayKey]);
	};

	focusTimeInput = (field, id, attempts = 4) => {
		const inputId = `${field}_${id}`;
		const focusAttempt = (remainingAttempts) => {
			const element = document.getElementById(inputId);
			if (element) {
				element.focus();
				return;
			}
			if (remainingAttempts > 0) {
				setTimeout(() => focusAttempt(remainingAttempts - 1), 0);
			}
		};
		focusAttempt(attempts);
	};

	triggerActiveTimeInputBlur = () => {
		if (typeof document === "undefined") return;
		const activeElement = document.activeElement;
		if (!activeElement || typeof activeElement.id !== "string") return;

		const isTimeInput =
			activeElement.id.startsWith("start_") ||
			activeElement.id.startsWith("end_");

		if (isTimeInput && typeof activeElement.blur === "function") {
			activeElement.blur();
		}
	};

	waitForPendingOperations = async (timeoutMs = 10000, pollMs = 50) => {
		const startedAt = Date.now();
		while (this.pendingOperationsCount > 0) {
			if (Date.now() - startedAt >= timeoutMs) {
				break;
			}
			await new Promise((resolve) => setTimeout(resolve, pollMs));
		}
	};

	closeModal() {
		this.props.hideModal();
	}

	openDeleteModal(time) {
		const endTime = time.end
			? moment.utc(time.end).local().format("HH:mm")
			: "--:--";

		var message = `<p>${this.props.t('times.registrations.deleteConfirmMsg')}</p>
						<p><strong>${moment.utc(time.start).local().format("DD/MM")}</strong>
						${this.props.t('times.registrations.deleteConfirmFrom')} <strong>${moment
							.utc(time.start)
							.local()
							.format("HH:mm")}</strong> ${this.props.t('times.registrations.deleteConfirmTo')} <strong>${endTime}</strong></p>`;

		this.props.showModal(
			{
				open: true,
				title: this.props.t('times.registrations.deleteTitle'),
				messageHTML: message,
				deleteAction: () => this.confirmDelete(time),
				closeModal: this.closeModal,
				style: { width: "300px" },
			},
			"delete"
		);
	}

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: title ? title : this.props.t('times.registrations.addErrorTitle'),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	openObservationsModal(time, titleObservations) {
		if (isTempTimeRegistration(time)) {
			this.openAlertModal(this.props.t("times.chat.saveTimeBeforeMessage"));
			return;
		}

		this.props.showModal(
			{
				open: true,
				title: titleObservations,
				style: { width: "520px", maxWidth: "95vw" },
				content: (
					<TimeObservationEdit
						getTimeList={this.getTimeList}
						time={time}
						employee={this.props.employee}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openLogsModal(time) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('times.logModal.title'),
				style: { width: "900px" },
				content: (
					<TimeRegistrationLogModal time={time} handleClose={this.closeModal} />
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// delete existing time
	confirmDelete = async (time) => {
		var id = time.id;

		this.incrementPendingOperations();
		try {
			//if not temp
			if (id.toString().lastIndexOf("temp") < 0) {
				await timesService.remove(id);
			}

			this.getTimeList();
			this.closeModal();

			toastr.success(this.props.t('common.success'), this.props.t('times.registrations.deleteSuccess'));
		} finally {
			this.decrementPendingOperations();
		}
	};

	// retrieve time list by employee and month
	async getTimeList() {
		const employee_id = this.state.employee_id;
		var day = this.state.current.getDate();
		const month = this.state.current.getMonth();
		const year = this.state.current.getFullYear();

		const start_from = moment(this.state.current)
			.startOf("month")
			.startOf("day")
			.toDate()
			.toISOString(); // esto hace la conversión a UTC

		const start_to = moment(this.state.current)
			.endOf("month")
			.endOf("day")
			.toDate()
			.toISOString();

		this.setState({
			loading: true,
		});

		let saved_times = await timesService.getAll({
			employee_id,
			start_from,
			start_to,
			page_size: 1000,
		});
		// console.log(saved_times);

		var times = [];

		// check if
		const isCurrent = this._checkIfCurrent();

		if (!isCurrent)
			day = moment(this.state.current).endOf("month").format("DD");

		// adding empty days
		for (var i = 1; i <= day; i++) {
			var d = new Date(year, month, i);

			let dia = {
				id: "temp_" + i,
				day: d,
				start: null,
				end: null,
				// type: this.props.default_time_type,
				assignments: [],
			};

			var existing_times = this._timeFilter(saved_times.data, d, i);

			if (existing_times.length > 0) times = [...times, ...existing_times];
			else {
				// si el timetype por defecto está entre los permitidos, lo mostramos, sino no
				const time_type = this.getEmployeeDefaultTimeType(d);
				if (time_type) dia.type = time_type;
				this.applyDefaultUbicationToRow(dia);

				times.push(dia);
			}
		}

		// order
		times = this._timeSort(times);
		// console.log(times);

		this.setState(
			{
				times: times,
				prevTimes: times,
				loading: false,
				isCurrentMonth: isCurrent,
			},
			() => {
				if (
					this.state.isCurrentMonth &&
					this.myRef &&
					typeof this.myRef.scrollIntoView === "function"
				) {
					this.myRef.scrollIntoView({ block: "start", behavior: "smooth" });
				}
			}
		);
	}

	// retrieve assignments list by employee and month
	async getAssignmentsList() {
		const employee_id = this.state.employee_id;
		const start_from = moment(this.state.current)
			.startOf("month")
			.format("YYYY-MM-DD");

		const start_to = moment(this.state.current)
			.endOf("month")
			.format("YYYY-MM-DD");

		const response = await plansService.getPlanAssignments({
			employee_id,
			start: start_from,
			end: start_to,
		});

		// console.log(response);
		const plan_assignments = response.data;
		// console.log(plan_assignments);

		this.setState({
			plan_assignments:
				!plan_assignments ||
				plan_assignments.length < 1 ||
				plan_assignments[0].plans.length < 1
					? []
					: plan_assignments[0].plans,
		});
	}

	// get objective hours list by employee and month
	async getObjectiveHoursList() {
		var { employee_id, account_objetivo } = this.state;

		if (!account_objetivo) {
			account_objetivo = await accountsService.getAll("Horas objetivo"); // guarrofix
		}

		const account_objetivo_id =
			account_objetivo.data.length > 0 ? account_objetivo.data[0].id : -1;

		const startDate = moment(this.state.current)
			.startOf("month")
			.format("YYYY-MM-DD");
		const endDate = moment(this.state.current)
			.endOf("month")
			.format("YYYY-MM-DD");

		// fetch horas objetivo
		const response_objective = await transactionsService.getAll(
			employee_id,
			account_objetivo_id,
			startDate,
			endDate,
			"",
			0,
			"+day"
		);
		const response_planned = await plansService.getPlannedHours({
			employee_id,
			start: startDate,
			end: endDate,
		});
		// console.log(employee_id);
		// console.log(response_objective);
		// console.log(response_planned);

		this.setState({
			account_objetivo,
			objective_hours: response_objective.data,
			planned_hours: normalizePlannedHoursList(response_planned),
		});
	}

	// retrieve calendar list by employee and month
	async getCalendarList() {
		const employee_id = this.state.employee_id;
		const start_from = moment(this.state.current)
			.startOf("month")
			.format("YYYY-MM-DD");
		const start_to = moment(this.state.current)
			.endOf("month")
			.format("YYYY-MM-DD");

		this.setState({
			loading: true,
		});

		const response = await calendarsService.getCalendarsByEmployee({
			employee_id,
			from: start_from,
			to: start_to,
		});

		// console.log(response);
		const employee_calendars = response;

		this.setState({
			employee_calendars:
				!employee_calendars.ok || employee_calendars.length < 1
					? []
					: employee_calendars,
		});
	}

	_timeFilter = (list, d, i) => {
		return list?.filter((time) => {
			let dia = moment.utc(time.start).local().format();
			let numdia = moment.utc(time.start).local().format("D");

			time.day = dia;
			return parseInt(numdia) === i;
		});
	};

	// time sorting from 1 to 30
	_timeSort = (list) => {
		return list.sort(function (a, b) {
			a = new Date(a.day);
			b = new Date(b.day);
			// return a>b ? -1 : a<b ? 1 : 0; // recent -> vell
			return a < b ? -1 : a > b ? 1 : 0; // vell -> recent
		});
	};

	// check if active month is current month
	_checkIfCurrent = () => {
		const today = new Date();
		const isCurrent =
			this.state.current.getFullYear() === today.getFullYear() &&
			this.state.current.getMonth() === today.getMonth();

		return isCurrent;
	};

	// back click - > history back
	handleBackClick = () => {
		this.props.history.goBack();
	};

	// updating active month +/- 1
	handleChangeMonth = (sum) => {
		const current = this.state.current;
		const newCurrent = moment(current).add(sum, "months");

		this.setState(
			{
				current: newCurrent.toDate(),
			},
			() => {
				this.getTimeList();
				this.getAssignmentsList();
				this.getObjectiveHoursList();
				this.getCalendarList();
			}
		);
	};

	/** Vuelve al mes en curso (vista “Hoy”). */
	handleGoToCurrentMonth = () => {
		if (this._checkIfCurrent()) {
			return;
		}
		const today = new Date();
		this.setState(
			{
				current: today,
			},
			() => {
				this.getTimeList();
				this.getAssignmentsList();
				this.getObjectiveHoursList();
				this.getCalendarList();
			}
		);
	};

	/** Separador semanal tipo mockup: primera fila del lunes tras otro día distinto. */
	isTimeRegWeekBoundaryRow = (time, index) => {
		if (index <= 0) return false;
		const d = moment(time.day).startOf("day");
		if (d.isoWeekday() !== 1) return false;
		const prev = moment(this.state.times[index - 1].day).startOf("day");
		return !d.isSame(prev, "day");
	};

	// switch approval state
	handleTimeApproval = async (event, time) => {
		const isApproved = event?.target?.checked;
		if (typeof isApproved !== "boolean") {
			return;
		}

		const dayKey = moment(time.day).format("YYYY-MM-DD");
		if (!this.approvalLock.tryBegin(dayKey)) {
			return;
		}
		this.markDayApproving(dayKey, true);

		const previousTimes = this.state.times;
		try {
			// Si el usuario pulsa aprobar justo al salir de un input, forzamos blur y
			// esperamos a que termine el guardado para evitar condiciones de carrera.
			this.triggerActiveTimeInputBlur();
			await new Promise((resolve) => setTimeout(resolve, 0));
			await this.waitForPendingOperations();

			const { times } = this.state;
			var approvalList = [];

			const updatedTimes = times.map((item) => {
				if (
					moment(item.day).format("YYYY-MM-DD") === dayKey &&
					item.start !== null &&
					item.end !== null
				) {
					const newItem = { ...item, approved: isApproved };
					approvalList.push({ id: newItem.id, approved: isApproved });
					return newItem;
				}
				return item;
			});

			trackHaddockEvent(
				"time_approval__single_day__toggled__time_registrations_page",
				{
					...getApprovalActorProps(this.props.user),
					surface: "time_registrations_page",
					action_type: "single_toggle",
					toggle_direction: isApproved ? "approve" : "unapprove",
					new_approved: isApproved,
					target_employee_id: this.state.employee_id || null,
					target_day: dayKey,
					affected_records_count: approvalList.length,
					filter_start_date: moment(this.state.current)
						.startOf("month")
						.format("YYYY-MM-DD"),
					filter_end_date: moment(this.state.current)
						.endOf("month")
						.format("YYYY-MM-DD"),
				}
			);

			this.setState({ times: updatedTimes });

			await this.handleApproval(updatedTimes, approvalList, {
				showSuccessToast: true,
				successMessage: isApproved
					? this.props.t('timeRegistrations.shiftApproved')
					: this.props.t('timeRegistrations.shiftUnapproved'),
				rollbackTimes: previousTimes,
			});
		} catch (error) {
			this.setState({ times: previousTimes });
			throw error;
		} finally {
			this.approvalLock.end(dayKey);
			this.markDayApproving(dayKey, false);
		}
	};

	handleMonthApproval = async () => {
		if (!this.approvalLock.tryBegin("month")) {
			return;
		}
		this.markDayApproving("month", true);

		try {
			this.triggerActiveTimeInputBlur();
			await new Promise((resolve) => setTimeout(resolve, 0));
			await this.waitForPendingOperations();

			const { times } = this.state;
			let approvalList = [];

			// Agrupar los fichajes por fecha (en formato YYYY-MM-DD)
			const groupedByDate = times.reduce((acc, item) => {
				const day = moment(item.start).format("YYYY-MM-DD");
				if (!acc[day]) acc[day] = [];
				acc[day].push(item);
				return acc;
			}, {});

			const updatedTimes = times.map((item) => {
				const day = moment(item.start).format("YYYY-MM-DD");
				const entriesForDay = groupedByDate[day];

				const allComplete = entriesForDay.every(
					(entry) => entry.start && entry.end !== null && entry.end !== undefined
				);

				if (allComplete && !item.approved) {
					const newItem = { ...item, approved: true };
					approvalList.push({ id: newItem.id, approved: true });
					return newItem;
				}

				return item;
			});

			trackHaddockEvent(
				"time_approval__bulk_month__clicked__time_registrations_page",
				{
					...getApprovalActorProps(this.props.user),
					surface: "time_registrations_page",
					action_type: "bulk_click",
					bulk_scope: "current_month",
					target_employee_id: this.state.employee_id || null,
					candidate_records_count: times.length,
					affected_records_count: approvalList.length,
					filter_start_date: moment(this.state.current)
						.startOf("month")
						.format("YYYY-MM-DD"),
					filter_end_date: moment(this.state.current)
						.endOf("month")
						.format("YYYY-MM-DD"),
				}
			);

			if (approvalList.length === 0) {
				this.openAlertModal(
					this.props.t('times.approveNoComplete'),
					this.props.t('times.approveErrorTitle')
				);
				return;
			}

			this.setState({ times: updatedTimes });
			await this.handleApproval(updatedTimes, approvalList, {
				showSuccessToast: true,
				successMessage: this.props.t('times.approveAllSuccess'),
				rollbackTimes: times,
			});
		} finally {
			this.approvalLock.end("month");
			this.markDayApproving("month", false);
		}
	};

	handleApproval = async (updatedTimes, approvalList, options = {}) => {
		const {
			showSuccessToast = false,
			successMessage = this.props.t('times.approveSuccess'),
			rollbackTimes,
		} = options;
		this.incrementPendingOperations();
		try {
			const response = await timesService.approve(approvalList);

			if (response.ok) {
				this.setState({
					times: updatedTimes,
				});
				if (showSuccessToast && approvalList.length > 0) {
					toastr.success(this.props.t('common.success'), successMessage);
				}
			} else {
				if (rollbackTimes) {
					this.setState({ times: rollbackTimes });
				}
				let textError = response.errors[0].description;

				this.openAlertModal(textError, this.props.t('times.approveErrorTitle'));
			}
			return response;
		} finally {
			this.decrementPendingOperations();
		}
	};

	getDeviceLabel = (deviceType) => {
		switch (deviceType) {
			case "browser":
				return "PC";
			case "mobile":
				return this.props.t('times.device.mobile');
			case "tablet":
				return "Tablet";
			default:
				return deviceType.charAt(0).toUpperCase() + deviceType.slice(1);
		}
	};

	handleChange = (rawValue, element, time) => {
		let id = time.id;
		let day = moment(time.day); // Usar moment para manejar la fecha
		let key = element.id.replace("_" + id, "");

		let value = "";

		if (rawValue !== "" && rawValue.includes(":")) {
			let [hours, minutes] = rawValue.split(":").map(Number);
			let valueMoment = day
				.clone()
				.set({ hour: hours, minute: minutes, second: 0 });

			if (key === "end") {
				let startMoment = moment(time.start);

				// Si 'end' es antes que 'start' y están en el mismo día
				if (valueMoment.isBefore(startMoment)) {
					if (
						valueMoment.hours() === startMoment.hours() &&
						valueMoment.minutes() === startMoment.minutes() &&
						valueMoment.seconds() < startMoment.seconds()
					) {
						// Solo incrementa un segundo
						valueMoment = startMoment.clone().add(1, "second");
					} else {
						// Si realmente es antes (en horas/minutos), suma un día
						valueMoment.add(1, "day");
					}
				}
			}

			// Ajusta para el DST automáticamente al usar moment
			value = valueMoment.toISOString();

			// Asigna el valor ajustado al estado, junto con información del dispositivo
			let device_type = this.getDeviceLabel(deviceType); // Asegúrate de definir deviceType, osName, y browserName

			this.setState((prevState, props) => {
				return {
					prevTimes: prevState.times,
					times: prevState.times.map((t) =>
						t.id === id
							? {
									...t,
									[key]: value,
									[key + "_origin"]:
										"[" + device_type + "] " + osName + ", " + browserName,
								}
							: t
					),
				};
			});
		} else {
			// Borra el valor si no es una hora válida
			if (key === "end") {
				this.setState((prevState, props) => {
					return {
						prevTimes: prevState.times,
						times: prevState.times.map((t) =>
							t.id === id ? { ...t, [key]: null } : t
						),
					};
				});
			}
		}
	};

	// handle time type on select change
	handleSelectType = (event, id) => {
		const { times } = this.state;
		const timeTypeId = parseInt(event.target.value);
		const type = this.props.select_time_types.find((t) => t.id === timeTypeId);

		const updatedTimes = times.map((item) => {
			if (item.id === id) {
				item.type = type;
				this.saveTime(id, item);
			}
			return item;
		});

		this.setState({
			prevTimes: times,
			times: updatedTimes,
		});
	};

	handleSelectUbication = (event, id) => {
		const { times } = this.state;
		const ubicationId = parseInt(event.target.value, 10);
		const options = this.getUbicationOptionsList();
		const opt = options.find((o) => o.id === ubicationId);

		const updatedTimes = times.map((item) => {
			if (item.id === id) {
				if (ubicationId > 0 && opt) {
					item.ubication = { id: opt.id, name: opt.name };
					item.ubication_id = opt.id;
				} else {
					item.ubication = null;
					item.ubication_id = null;
				}
				this.saveTime(id, item);
			}
			return item;
		});

		this.setState({
			prevTimes: times,
			times: updatedTimes,
		});
	};

	handleTimeInputKeyDown = (id, field, event) => {
		if (event.key !== "Enter" || field !== "end") return;
		event.preventDefault();

		if (event.target && typeof event.target.blur === "function") {
			event.target.blur();
		}
	};

	// handle input blur -- > save time
	handleBlur = (id, event) => {
		const sourceElementId = event?.target?.id;
		const nextElementId = event?.relatedTarget?.id;
		const isMovingWithinSameTimeRow =
			typeof nextElementId === "string" &&
			(nextElementId === `start_${id}` || nextElementId === `end_${id}`);
		const shouldPersistFocusOnNextInput =
			typeof nextElementId === "string" &&
			(nextElementId === `start_${id}` || nextElementId === `end_${id}`) &&
			typeof sourceElementId === "string" &&
			sourceElementId !== nextElementId;

		const hasChanged = this.state.times !== this.state.prevTimes;
		// console.log(this.state.times);
		// console.log(this.state.prevTimes);

		if (hasChanged) {
			const state_time = this.state.times?.filter((t) => t.id === id);
			//console.log(state_time[0]);
			if (shouldPersistFocusOnNextInput) {
				const focusField = nextElementId.startsWith("start_") ? "start" : "end";
				this.saveTime(id, state_time[0], { focusFieldAfterSave: focusField });
				return;
			}
			this.saveTime(id, state_time[0]);
		} else if (isMovingWithinSameTimeRow && typeof sourceElementId === "string") {
			// Si no hubo cambios, mantenemos el comportamiento natural de foco.
			return;
		}
	};

	// add new time or update existing one
	saveTime = async (id, state_time, options = {}) => {
		const { focusFieldAfterSave = null } = options;
		const saveKey = `save:${id}`;
		if (!this.approvalLock.tryBegin(saveKey)) {
			return;
		}

		try {
		// console.log(state_time);

		if (state_time.start === null || state_time.start === "") {
			// do nothing
		} else {
			if (state_time === undefined)
				state_time = this.state.times?.filter((t) => t.id === id)[0];

			// AJUSTE FECHA DE SALIDA ANTES DE PASAR A UTC
			if (state_time.start && state_time.end) {
				let startLocal = moment(state_time.start);
				let endLocal = moment(state_time.end);

				if (startLocal.isValid() && endLocal.isValid()) {
					// 1) Si la salida es <= que la entrada, la movemos al día siguiente
					if (!endLocal.isAfter(startLocal)) {
						endLocal = endLocal.add(1, "day");
					}

					// 2) Si la duración es > 24h, restamos un día a la salida
					const diffHours = endLocal.diff(startLocal, "hours", true);
					const MAX_HOURS = 24;

					if (diffHours > MAX_HOURS) {
						endLocal = endLocal.subtract(1, "day");
					}

					// Dejamos el valor ajustado en state_time.end
					state_time.end = endLocal.toDate();
				}
			}
			// FIN AJUSTE

			let start_utc = null;
			let end_utc = null;

			if (state_time.start) start_utc = moment.utc(state_time.start).format();

			if (state_time.end) end_utc = moment.utc(state_time.end).format();

			const isValidDate =
				moment(state_time.start).isValid() && moment(state_time.end).isValid();

			let approved = false;
			if (
				state_time.approved !== undefined &&
				state_time.approved &&
				isValidDate
			)
				approved = true;

			const timeBase = {
				start: start_utc,
				end: end_utc,
				approved: approved,
				type_id: state_time.type ? state_time.type.id : -1,
				start_origin: state_time.start_origin,
				end_origin: state_time.end_origin,
				employee_id: this.state.employee_id,
				start_source: state_time.start_source || "TIME_REGISTRATIONS",
				end_source: "TIME_REGISTRATIONS",
			};

			const isExisting = id.toString().lastIndexOf("temp") < 0;
			const time = isExisting
				? withUbicationId(timeBase, state_time, { echo: true })
				: withUbicationId(
						timeBase,
						resolveUbicationId(state_time) ?? -1,
						{ echo: false }
					);

			var update_assignments = false;

			// Incrementar el contador de operaciones pendientes
			this.incrementPendingOperations();

			try {
				// if not "temp" -> update existing
				if (isExisting) {
					const response = await timesService.update(id, time);
					// console.log(response);
					if (!response.ok) {
						let textError = response.errors[0].description;
						this.openAlertModal(textError);

						// gets old saved version
						const fetch_time = await timesService.getById(id);
						fetch_time.day = fetch_time.start;

						this.setState({
							times: this.state.times.map((t) =>
								t.id === id ? fetch_time : t
							),
						});
					} else {
						this.updateTimeView(id, response);
						if (focusFieldAfterSave) {
							this.focusTimeInput(focusFieldAfterSave, response.id);
						}
						update_assignments = true;
					}
				} else {
					// if "temp" -> add new time
					const response = await timesService.add(time);
					// update list so the time id gets updated
					if (!response.ok) {
						let textError = response.errors[0].description;
						this.openAlertModal(textError);

						const reset_time = {
							id: id,
							day: state_time.day,
							start: null,
							end: null,
							approved: false,
							// type: this.props.default_time_type,
						};

						// si el timetype por defecto está entre los permitidos, lo mostramos, sino no
						const time_type = this.getEmployeeDefaultTimeType(state_time.day);
						if (time_type) reset_time.type = time_type;

						this.setState({
							times: this.state.times.map((t) =>
								t.id === id ? reset_time : t
							),
						});
					} else {
						this.updateTimeView(id, response);
						if (focusFieldAfterSave) {
							this.focusTimeInput(focusFieldAfterSave, response.id);
						}
						update_assignments = true;
					}
				}

				const day_assignments = this.getDayAssignments(time.start);

				// Si el fichaje se ha creado ok y se crea turno actualizamos lista de assignments
				if (
					update_assignments &&
					(day_assignments.length === 0 ||
						(day_assignments.length === 1 &&
							day_assignments[0].shift.type !== shiftType.work))
				) {
					this.getAssignmentsList();
					this.getObjectiveHoursList();
				}
			} finally {
				// Decrementar el contador de operaciones pendientes
				this.decrementPendingOperations();
			}
		}
		} finally {
			this.approvalLock.end(saveKey);
		}
	};

	// update time record if response object is different (= time correction)
	updateTimeView = (id, obj) => {
		const { times } = this.state;
		const index = times.findIndex((x) => x.id === id);

		if (index === -1) {
			console.warn(`No se encontró un registro de tiempo con id: ${id}`);
			return;
		}

		const isSame =
			moment(obj.start).isSame(times[index].start) &&
			(!moment(times[index].end).isValid() ||
				moment(obj.end).isSame(times[index].end));

		times[index].id = obj.id;
		times[index].start = obj.start;
		times[index].end = obj.end;
		if (obj.type) times[index].type = obj.type;
		if (obj.ubication !== undefined) times[index].ubication = obj.ubication;

		this.setState({ times });

		if (isSame) {
			toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
		} else {
			toastr.warning(this.props.t('common.correction'), this.props.t('times.timeCorrection'));
		}
	};

	getEmployeeDefaultTimeType = (date) => {
		const { select_time_types, default_time_type } = this.props;
		const { employee_time_types_list } = this.state;

		const filtered_employee_types =
			employee_time_types_list.length > 0
				? getEmployeeTimeTypes(employee_time_types_list, date)
				: [];
		const time_types_list =
			filtered_employee_types.length > 0
				? filtered_employee_types
				: select_time_types;

		// Verificar que default_time_type existe antes de acceder a sus propiedades
		if (!default_time_type) {
			return time_types_list.length > 0 ? time_types_list[0] : null;
		}

		const time_type = time_types_list.find(
			(tt) => tt.id === default_time_type.id
		);

		return time_type;
	};

	// add time in list (without saving)
	handleAddTime = (event, date) => {
		var times = this.state.times;
		let conta = times.length + 1;

		let dia = {
			id: "temp_" + conta,
			day: moment(date).toDate(),
			start: null,
			end: null,
			// type: this.props.default_time_type,
		};

		// si el timetype por defecto está entre los permitidos, lo mostramos, sino no
		const time_type = this.getEmployeeDefaultTimeType(date);
		if (time_type) dia.type = time_type;
		this.applyDefaultUbicationToRow(dia);

		times = times.concat(dia);
		times = this._timeSort(times);

		this.setState({
			times,
		});
	};

	// renders content
	getContent = () => {
		const { isMe } = this.state;

		if (this.state.loading) {
			return <Loading />;
		}

		if (!isMe && !this.props.employee) {
			return <div className="no-results"><p>{this.props.t('times.errorLoading')}</p></div>;
		}

		const { employee } = this.props;
		const title = isMe
			? this.props.t('times.tabs.myTimes')
			: employee.name + " " + employee.surname;

		const monthSummary = this.getMonthSummaryMetrics();

		return (
			<>
				<div
					className={
						isMe ? "heading time-registrations-heading--mis-fichajes" : "heading"
					}
				>
					<div className="heading-left">
						<h1 className="title">{title}</h1>
					</div>
				</div>

				<TimesNavigationTabs selectedEmployee={isMe ? null : employee} />

				<TimeRegistrationsMonthSummary
					workedLabel={monthSummary.workedDisplay}
					targetLabel={monthSummary.targetDisplay}
					targetCaption={monthSummary.targetCaption}
					balanceLabel={monthSummary.balanceDisplay}
					balanceShortRaw={monthSummary.balanceShortRaw}
				/>

				<div className="subheading-time-registrations">
					{this.renderMonthNavigation()}
					{(isAdmin() || isSupervisor()) && (
						<div className="subheading-actions">
							<OverlayTrigger
								placement="bottom"
								overlay={
									this.state.pendingOperations > 0 ? (
										<Tooltip>
											{this.props.t('timeRegistrations.waitForUpdates')}
										</Tooltip>
									) : (
										<span></span>
									)
								}
							>
								<span>
									<button
										type="button"
										onClick={this.handleMonthApproval}
										className="btn btn-outline-primary btn-aprobar btn-aprobar-with-icon"
										disabled={this.state.pendingOperations > 0}
									>
										<IoCheckmarkDoneOutline
											className="btn-aprobar__icon"
											aria-hidden
										/>
										{this.props.t('timeRegistrations.approvePending')}{" "}
										<Moment format="MMMM">{this.state.current}</Moment>
									</button>
								</span>
							</OverlayTrigger>
						</div>
					)}
				</div>

				{this.state.useDesktopDataTable ? (
					<div className="w-100 time-registrations-datatable-wrap">
						<DataTable
							tableClassName="table-time-registrations table-hover"
							columns={this.getDesktopColumns()}
							rows={this.getDesktopTableRows()}
							rowKey={this.desktopRowKey}
							rowClassName={this.desktopRowClassName}
							showHeaderSortAffix={false}
							emptyMessage={this.props.t('timeRegistrations.errorLoadingTimes')}
						/>
					</div>
				) : (
					<MobileOrTablet>
						<div
							className={[
								"time-registration-day-cards-wrap",
								!this.state.useDesktopDataTable &&
								(isAdmin() || isSupervisor())
									? "time-registration-day-cards-wrap--with-approve-bar"
									: "",
							]
								.filter(Boolean)
								.join(" ")}
						>
							{this.state.times.length === 0
								? this.getErrorRow()
								: this.renderMobileDayCards()}
						</div>
					</MobileOrTablet>
				)}

				{!this.state.useDesktopDataTable && (isAdmin() || isSupervisor()) && (
					<div className="time-registrations-mobile-approve-bar">
						<OverlayTrigger
							placement="top"
							overlay={
								this.state.pendingOperations > 0 ? (
									<Tooltip>
										Espera a que se completen las actualizaciones en curso
									</Tooltip>
								) : (
									<span></span>
								)
							}
						>
							<span className="time-registrations-mobile-approve-bar__inner">
								<button
									type="button"
									onClick={this.handleMonthApproval}
									className="btn btn-primary btn-block time-registrations-mobile-approve-bar__btn"
									disabled={this.state.pendingOperations > 0}
								>
									Aprobar fichajes pendientes{" "}
									<Moment format="MMMM">{this.state.current}</Moment>
								</button>
							</span>
						</OverlayTrigger>
					</div>
				)}
			</>
		);
	};

	renderMonthNavigation = () => (
		<div className="time-registrations-month-nav">
			<button
				type="button"
				className="btn btn-sm btn-outline-secondary time-registrations-month-nav__today"
				onClick={this.handleGoToCurrentMonth}
				disabled={this._checkIfCurrent()}
			>
				{this.props.t('datePresets.today')}
			</button>
			<div className="time-registrations-month-nav__chevrons">
				<button
					type="button"
					className="btn-transparent time-registrations-month-nav__chevron"
					onClick={() => this.handleChangeMonth(-1)}
					aria-label={this.props.t("calendar.previousMonth")}
				>
					<FiChevronLeft />
				</button>
				{!this._checkIfCurrent() && (
					<button
						type="button"
						className="btn-transparent time-registrations-month-nav__chevron"
						onClick={() => this.handleChangeMonth(1)}
						aria-label={this.props.t("calendar.nextMonth")}
					>
						<FiChevronRight />
					</button>
				)}
			</div>
			<span className="time-registrations-month-nav__label">
				<Moment format="MMMM YYYY">{this.state.current}</Moment>
			</span>
		</div>
	);

	getErrorRow = () => {
		return <div className="no-results"><p>{this.props.t('times.registrations.errorLoading')}</p></div>;
	};

	getDayCardGroups = () => {
		const { times } = this.state;
		const map = new Map();
		times.forEach((time, index) => {
			const k = moment(time.day).format("YYYY-MM-DD");
			if (!map.has(k)) map.set(k, []);
			map.get(k).push({ time, index });
		});
		return Array.from(map.entries());
	};

	renderApprovalCell = (time) => {
		if (!this.isFichajeCompleto(time)) {
			return null;
		}
		const { isEmployeeActive, pendingOperations } = this.state;
		if ((isAdmin() || isSupervisor()) && isEmployeeActive) {
			return (
				<SwitchCompact
					controlId={`approved_${time.id}`}
					isOn={time.approved}
					disabled={this.isDayApprovalInFlight(time) || pendingOperations > 0}
					handleToggle={(e) => this.handleTimeApproval(e, time)}
				/>
			);
		}
		return time.approved ? (
			<span title="SI" className="bolita bolita-true" />
		) : (
			<span title="NO" className="bolita bolita-false" />
		);
	};

	renderMobileDayCards = () =>
		this.getDayCardGroups().map(([dayKey, entries]) => {
			const first = entries[0];
			const showWeek = this.isTimeRegWeekBoundaryRow(
				first.time,
				first.index
			);
			const segments = entries.map(({ time, index }) => ({
				time,
				derived: this.deriveTimeRow(time, index),
			}));
			const isTodayCard = segments.some((s) => s.derived.isToday);
			return (
				<TimeRegistrationDayCard
					key={dayKey}
					segments={segments}
					showWeekBoundary={showWeek}
					isTodayCard={isTodayCard}
					renderTimeInputs={(time, disabled) =>
						this.getTimeInputs(time, disabled, {
							betweenSeparator: "-",
						})
					}
					shouldShowAddTime={this.shouldShowAddTimeButtonMobile}
					onAddTime={this.handleAddTime}
					getTimeType={this.getTimeType}
					getUbication={
						this.getUbicationOptionsList().length > 0
							? this.getUbication
							: undefined
					}
					getActionsCell={this.getActionsCell}
					getShiftList={this.getShiftList}
					getObservations={this.getObservations}
					hasObservationsOrAttachments={this.hasObservationsOrAttachments}
					renderApprovalControl={this.renderApprovalCell}
				/>
			);
		});

	getActionsMenu = (time) => {
		var titleObservations = hasTimeChat(time)
			? this.props.t('times.registrations.editObservations')
			: this.props.t('times.registrations.addObservations');

		return (
			<Dropdown>
				<Dropdown.Toggle variant="action">
					<FiMoreHorizontal />
				</Dropdown.Toggle>
				<Dropdown.Menu style={{ margin: 0 }}>
					<Dropdown.Item
						as="button"
						className="option-observations"
						onClick={() => this.openObservationsModal(time, titleObservations)}
					>
						{titleObservations}
					</Dropdown.Item>
					<Dropdown.Item
						as="button"
						className="option-add-time"
						onClick={(e) => this.handleAddTime(e, time.day)}
					>
						{this.props.t('times.registrations.addTime')}
					</Dropdown.Item>
					<Dropdown.Item
						as="button"
						className="option-logs"
						onClick={() => this.openLogsModal(time)}
					>
						{this.props.t('times.registrations.viewModifications')}
					</Dropdown.Item>
					<Dropdown.Item
						className="option-delete"
						as="button"
						onClick={() => this.openDeleteModal(time)}
					>
						{this.props.t('times.registrations.deleteTime')}
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		);
	};

	/** Sin menú usable (fila vacía: SCSS oculta opciones; fila solo lectura): no mostrar toggle para no confundir. */
	getActionsCell = (time, rowDisabled) => {
		const isEmptyRow = time.start == null;
		if (rowDisabled || isEmptyRow) {
			return null;
		}
		return this.getActionsMenu(time);
	};

	formatShiftIntervalLabels = (time_intervals) => {
		if (!time_intervals || time_intervals.length === 0) return [];

		const toLocalHm = (v) => {
			if (v == null || v === "") return "";
			let s = convertFromUTC(v);
			if (s) return s;
			const m = moment(v);
			if (m.isValid()) return m.local().format("HH:mm");
			if (typeof v === "string") {
				const trimmed = v.trim();
				if (/^\d{1,2}:\d{2}/.test(trimmed)) return trimmed.slice(0, 5);
			}
			return "";
		};

		return time_intervals
			.map((item) => {
				const start = toLocalHm(item.start);
				const end = toLocalHm(item.end);
				const short = (t) => {
					if (!t) return "";
					const [h, mPart] = t.split(":");
					const mins = mPart ?? "00";
					return mins === "00" ? h : `${h}:${mins}`;
				};
				if (!start && !end) return "";
				return `${short(start)}-${short(end)}h`;
			})
			.filter(Boolean);
	};

	isFichajeCompleto = (time) => {
		if (time.start == null || time.end == null) return false;
		return moment(time.start).isValid() && moment(time.end).isValid();
	};

	/**
	 * Móvil (day cards): el (+) solo en el primer fichaje del día y con entrada+salida informadas,
	 * para añadir otro tramo cuando el actual está cerrado (mock “Mis fichajes”).
	 */
	shouldShowAddTimeButtonMobile = (time) => {
		const { times } = this.state;
		const index = times.findIndex((t) => t.id === time.id);
		if (index === -1) return false;
		let isMain = true;
		if (index > 0) {
			const prevDay = new Date(times[index - 1].day).getDate();
			const curDay = new Date(time.day).getDate();
			if (prevDay === curDay) isMain = false;
		}
		return isMain && this.isFichajeCompleto(time);
	};

	renderFichajesCell = (time, disabled) => {
		const showAdd =
			this.state.useDesktopDataTable ||
			this.shouldShowAddTimeButtonMobile(time);
		return (
			<div className="time-registrations-fichajes-cell">
				{this.getTimeInputs(time, disabled)}
				{showAdd && (
					<TimeRegistrationAddTimeButton
						onClick={(e) => this.handleAddTime(e, time.day)}
					/>
				)}
			</div>
		);
	};

	getTimeInputs = (
		time,
		disabled,
		{ betweenSeparator } = {},
	) => {
		// fix de input time para safari
		const isModernIOS =
			isSafari && /OS (1[6-9]|[2-9][0-9])_/.test(navigator.userAgent);

		const time_start =
			time.start === null || time.start === undefined
				? ""
				: moment.utc(time.start).local().format("HH:mm");
		const time_end =
			time.end === null || time.end === undefined
				? ""
				: moment.utc(time.end).local().format("HH:mm");

		return (
			<form className="td-flex nowrap" noValidate>
				<span className="time-container" style={{ position: "relative" }}>
					<TimeInputWithArrows
						id={`start_${time.id}`}
						disabled={disabled}
						className="form-time"
						value={time_start}
						placeholder={isModernIOS ? "--:--" : "HH:mm"}
						showDecorators={false}
						onChange={(event) =>
							this.handleChange(
								event.target.value,
								{ id: event.target.id },
								time
							)
						}
						onBlur={(event) => this.handleBlur(time.id, event)}
						nextInputId={`end_${time.id}`}
						required
					/>
				</span>
				{betweenSeparator ? (
					<span
						className="time-registration-day-card-top-bar__time-sep"
						aria-hidden
					>
						{betweenSeparator}
					</span>
				) : null}
				<span className="time-container" style={{ position: "relative" }}>
					<TimeInputWithArrows
						id={`end_${time.id}`}
						disabled={disabled}
						className="form-time"
						value={time_end}
						placeholder={isModernIOS ? "--:--" : "HH:mm"}
						showDecorators={false}
						onChange={(event) =>
							this.handleChange(
								event.target.value,
								{ id: event.target.id },
								time
							)
						}
						onBlur={(event) => this.handleBlur(time.id, event)}
						onKeyDown={(event) =>
							this.handleTimeInputKeyDown(time.id, "end", event)
						}
						required
					/>
				</span>
			</form>
		);
	};

	getTimeTypeOptionsList = (time) => {
		const { select_time_types } = this.props;
		const { employee_time_types_list } = this.state;

		const filtered_employee_types =
			employee_time_types_list.length > 0
				? getEmployeeTimeTypes(employee_time_types_list, time.day)
				: [];
		const time_types_list =
			filtered_employee_types.length > 0
				? filtered_employee_types
				: select_time_types;

		let options = [];
		if (Array.isArray(time_types_list) && time_types_list.length > 0) {
			options = time_types_list.map((item) => ({
				id: item.id,
				name: this.props.t(`timeTypes.names.${item.name}`, { defaultValue: item.name }),
			}));
		}

		const pausaType = this.props.select_time_types.find(
			(t) =>
				t.name.toLowerCase().trim() === "pausa" ||
				t.name.toLowerCase().includes("pausa")
		);

		if (
			pausaType &&
			Array.isArray(time_types_list) &&
			!time_types_list.find((t) => t.id === pausaType.id)
		) {
			options.push({ id: pausaType.id, name: pausaType.name });
		}

		return options;
	};

	getTimeType = (time, disabled) => {
		return (
			<TimeRegistrationTypeSelect
				id={`type_${time.id}`}
				disabled={disabled}
				value={
					time.type && time.type.id != null ? time.type.id : -1
				}
				options={this.getTimeTypeOptionsList(time)}
				onChange={(e) => this.handleSelectType(e, time.id)}
			/>
		);
	};

	getUbication = (time, disabled) => {
		const options = this.getUbicationOptionsList();
		if (!options.length) return null;

		return (
			<TimeRegistrationUbicationSelect
				id={`ubication_${time.id}`}
				disabled={disabled}
				value={this.getUbicationSelectValue(time)}
				options={options}
				onChange={(e) => this.handleSelectUbication(e, time.id)}
			/>
		);
	};

	getObservations = (time) => {
		var titleObservations = hasTimeChat(time)
			? this.props.t('times.registrations.editObservations')
			: this.props.t('times.registrations.addObservations');

		return (
			<FaRegComment
				className="icon-comment"
				title={this.props.t('times.chat.viewConversation')}
				onClick={() => this.openObservationsModal(time, titleObservations)}
			/>
		);
	};

	hasObservationsOrAttachments = (time) => hasTimeChatOrAttachments(time);

	getDayAssignments = (day) => {
		const { plan_assignments } = this.state;
		const filtered_assignments = plan_assignments?.filter((d) => {
			// let selected_day = moment.utc(day).local().format("D");
			// let d_day = moment.utc(d.day).local().format("D");

			let selected_day = moment(day).format("D");
			let d_day = moment(d.day).format("D");

			// console.log("****");
			// console.log(moment(day).format("YYYY-MM-DD"));
			// console.log(d.day);
			// console.log(selected_day);
			// console.log(d_day);

			return selected_day === d_day;
		});

		const day_assignments = filtered_assignments[0]
			? filtered_assignments[0].assignments
			: [];
		// console.log(day);

		// console.log(day_assignments);

		return day_assignments;
	};

	getShiftList = (day) => {
		const day_assignments = this.getDayAssignments(day);
		// console.log(day_assignments);

		if (day_assignments === undefined || day_assignments.length < 1) return "";

		return (
			<div className="time-registrations-shift-tags">
				{this.getAssignedShifts(day_assignments)}
			</div>
		);
	};

	getAssignedShifts = (day_assignments) =>
		day_assignments.map((item) => {
			const shift = item.shift;
			const time_intervals =
				item.time_intervals && item.time_intervals.length > 0
					? item.time_intervals
					: shift.time_intervals || [];
			const tooltip = (
				<Tooltip className="tooltip-shift">
					<ShiftPreviewTooltip
						shift={shift}
						time_intervals={time_intervals}
					/>
				</Tooltip>
			);
			const title = `${shift.name}${
				shift.description ? ` - ${shift.description}` : ""
			}`;
			const textColor = getContrastColor(shift.background_color, "#0d0a2c");
			const intervalParts = this.formatShiftIntervalLabels(time_intervals);
			const schedule = intervalParts.length > 0 ? intervalParts.join(" · ") : "";

			return (
				<OverlayTrigger key={item.id} overlay={tooltip}>
					<div className="time-registrations-shift-tags__item">
						<TimeRegistrationShiftTag
							name={shift.name}
							schedule={schedule}
							backgroundColor={shift.background_color || undefined}
							borderColor={
								shift.border_color
									? shift.border_color
									: shift.background_color || undefined
							}
							textColor={textColor}
							title={title}
						/>
					</div>
				</OverlayTrigger>
			);
		});

	// DAY TYPES
	getDayType = (day) => {
		const { employee_calendars } = this.state;
		const filtered_calendar = employee_calendars?.filter((d) => {
			let selected_day = moment(day).format("D");
			let d_day = moment(d.day).format("D");

			return selected_day === d_day;
		});

		// console.log(filtered_calendar);

		return filtered_calendar[0] ? filtered_calendar[0].day_type : {};
	};

	getBalanceByDay = (day, list) => {
		const filtered_hours = list?.filter((d) => {
			let selected_day = moment(day).format("D");
			let d_day = moment(d.day).format("D");

			return selected_day === d_day;
		});

		// console.log(filtered_hours);
		const suma = filtered_hours?.reduce((acc, numero) => acc + numero.value, 0);

		var return_value = 0;
		if (filtered_hours?.length === 1) return_value = filtered_hours[0].value;
		else if (filtered_hours?.length > 1) return_value = suma;

		const formattedValue = new Intl.NumberFormat("de-DE", {
			minimumFractionDigits: 1,
			maximumFractionDigits: 2,
		}).format(return_value);
		return formattedValue;
	};

	_parseNumericHours = (v) => {
		if (v == null || v === "") return 0;
		const n = Number(String(v).replace(",", "."));
		return Number.isFinite(n) ? n : 0;
	};

	getMonthSummaryMetrics = () => {
		const { times, objective_hours, planned_hours } = this.state;
		const { user } = this.props;
		const workedSeconds = getWorkedTimeRaw({ times, unit: "seconds" });
		// Misma base y formato que la columna "Total trabajado" / encabezado (getWorkedTime).
		const workedDisplay = getWorkedTime(times);
		const useTarget =
			user.time_registration_balance_calculation === "TARGET_HOURS";
		const objectiveMonth = (objective_hours || []).reduce(
			(a, h) => a + this._parseNumericHours(h.value),
			0
		);
		const plannedMonth = (planned_hours || []).reduce(
			(a, h) => a + this._parseNumericHours(h.value),
			0
		);
		const targetHours = useTarget ? objectiveMonth : plannedMonth;
		const balance = getBalanceHours(targetHours, workedSeconds);
		const targetSeconds = Math.round(Number(targetHours) * 3600);

		return {
			workedDisplay,
			targetDisplay: formatSecondsToTime(targetSeconds, "hm"),
			balanceDisplay: balance.short,
			balanceShortRaw: balance.short_raw,
			targetCaption: useTarget ? this.props.t("times.balance.objectiveHours") : this.props.t("times.balance.plannedHoursLabel"),
		};
	};

	/**
	 * Valores derivados por fila (escritorio y lógica compartida con la vista móvil).
	 */
	deriveTimeRow = (time, i) => {
		var isMain = true;
		const {
			isMe,
			isCurrentMonth,
			allow_manual_time_registrations,
			objective_hours,
			planned_hours,
			isEmployeeActive,
		} = this.state;
		const balance_calcularion =
			this.props.user.time_registration_balance_calculation;
		var disabled = time.approved;

		if (
			(!isMe && !isAdmin() && !isSupervisor()) ||
			!allow_manual_time_registrations ||
			!isEmployeeActive
		) {
			disabled = true;
		}

		const start = new Date(time.start);
		const end = new Date(time.end);
		var minutes = getDiffTime(start, end);
		if (minutes < 0) minutes = 0;
		const hours = formatMinutesToTime(minutes);

		if (i > 0) {
			const prev = new Date(this.state.times[i - 1].day).getDate();
			const now = new Date(time.day).getDate();
			if (prev === now) isMain = false;
		}

		var total = -1;
		var balance = 0;
		var balanceTitle = "";
		var tooltipInfo = "";
		var sTipoTiempo = "";

		if (isMain) {
			var total_raw = getWorkedTimeRaw({
				times: this.state.times,
				date: time.start,
				unit: "seconds",
			});
			total = formatSecondsToTime(total_raw, "hm");

			const objective_hours_day = this.getBalanceByDay(
				time.day,
				objective_hours
			);
			const planned_hours_day = this.getBalanceByDay(time.day, planned_hours);

			if (minutes > 0) {
				if (balance_calcularion === "TARGET_HOURS") {
					balance = getBalanceHours(objective_hours_day, total_raw);
					sTipoTiempo = " " + this.props.t('times.balance.targetHours');
				} else {
					balance = getBalanceHours(planned_hours_day, total_raw);
					sTipoTiempo = " " + this.props.t('times.balance.plannedHours');
				}

				if (balance.short_raw > 0)
					balanceTitle = (
						<p className="tooltip-title">
							{this.props.t('times.balance.excessText')} <strong>{balance.formated}</strong>{" "}
							{this.props.t('times.balance.accordingTo')}{sTipoTiempo}
						</p>
					);

				if (balance.short_raw < 0)
					balanceTitle = (
						<p className="tooltip-title">
							{this.props.t('times.balance.shortText')} <strong>{balance.formated}</strong> {this.props.t('times.balance.shortSuffix')}
							{sTipoTiempo}
						</p>
					);

				tooltipInfo = (
					<Tooltip className="tooltip-balance">
						<p>
							{this.props.t('times.balance.targetLabel')}: <strong>{objective_hours_day}h</strong>
						</p>
						<p>
							{this.props.t('times.balance.plannedLabel')}: <strong>{planned_hours_day}h</strong>
						</p>
						{balanceTitle}
					</Tooltip>
				);
			}
		}

		const today = new Date();
		const isToday =
			isCurrentMonth && new Date(time.day).getDate() === today.getDate();

		const dayTypeRaw = this.getDayType(time.day);
		const day_type =
			dayTypeRaw && Object.keys(dayTypeRaw).length > 0 ? dayTypeRaw : null;

		return {
			isMain,
			disabled,
			minutes,
			hours,
			total,
			balance,
			tooltipInfo,
			day_type,
			isToday,
		};
	};

	getDesktopTableRows = () =>
		this.state.times.map((time, index) => ({
			time,
			index,
			...this.deriveTimeRow(time, index),
		}));

	getDesktopColumns = () => {
		const { isEmployeeActive } = this.state;

		return [
			{
				key: "day",
				header: this.props.t('common.day'),
				sortable: false,
				headerClassName: "col-time-reg-day",
				className: "col-time-reg-day",
				render: (row) => (
					<TimeRegistrationDayTag
						time={row.time.day}
						dayType={row.day_type}
					/>
				),
			},
			{
				key: "fichajes",
				header: this.props.t('times.table.fichajes'),
				sortable: false,
				headerClassName: "col-time-reg-fichajes",
				className: "col-time-reg-fichajes",
				render: (row) => this.renderFichajesCell(row.time, row.disabled),
			},
			{
				key: "tipo",
				header: this.props.t('common.type'),
				sortable: false,
				headerClassName: "col-time-reg-tipo",
				className: "col-time-reg-tipo",
				render: (row) => this.getTimeType(row.time, row.disabled),
			},
			...(this.getUbicationOptionsList().length > 0
				? [
						{
							key: "ubicacion",
							header: this.props.t('times.table.ubication'),
							sortable: false,
							headerClassName: "col-time-reg-ubication",
							className: "col-time-reg-ubication",
							render: (row) => this.getUbication(row.time, row.disabled),
						},
					]
				: []),
			{
				key: "add",
				header: "\u00A0",
				sortable: false,
				render: (row) => (
					<button
						type="button"
						title={this.props.t('times.registrations.addTime')}
						onClick={(e) => this.handleAddTime(e, row.time.day)}
						className="btn btn-new btn-new-small"
					>
						<FiPlus />
					</button>
				),
			},
			{
				key: "obs",
				header: "\u00A0",
				sortable: false,
				render: (row) =>
					this.hasObservationsOrAttachments(row.time) &&
					this.getObservations(row.time),
			},
			{
				key: "tiempo",
				header: this.props.t('timeRegistrations.colTime'),
				sortable: false,
				render: (row) => row.hours,
			},
			{
				key: "total_trabajado",
				header: this.props.t('times.table.dayTotal'),
				sortable: false,
				className: "col-total",
				render: (row) =>
					row.total !== -1 && row.minutes !== 0 ? row.total : "-",
			},
			{
				key: "balance",
				header: this.props.t('times.table.balance'),
				sortable: false,
				className: "col-balance",
				render: (row) =>
					row.tooltipInfo ? (
						<OverlayTrigger overlay={row.tooltipInfo}>
							<span
								className={`${
									row.balance.short_raw > 0 ? "color-green-dark" : ""
								}  ${row.balance.short_raw < 0 ? "color-red" : ""}`}
							>
								{row.balance.short}
							</span>
						</OverlayTrigger>
					) : (
						<span
							className={`${
								row.balance.short_raw > 0 ? "color-green-dark" : ""
							}  ${row.balance.short_raw < 0 ? "color-red" : ""}`}
						>
							{row.balance.short}
						</span>
					),
			},
			{
				key: "turnos",
				header: this.props.t('timeRegistrations.colShifts'),
				sortable: false,
				headerClassName: "col-time-reg-turnos",
				className: "col-time-reg-turnos",
				render: (row) => row.isMain && this.getShiftList(row.time.day),
			},
			{
				key: "approved",
				header: this.props.t('times.table.approved'),
				sortable: false,
				render: (row) =>
					!this.isFichajeCompleto(row.time) ? null : (isAdmin() ||
							isSupervisor()) && isEmployeeActive ? (
						<Switch
							controlId={`approved_${row.time.id}`}
							isOn={row.time.approved}
							disabled={
								this.isDayApprovalInFlight(row.time) ||
								this.state.pendingOperations > 0
							}
							handleToggle={(e) => this.handleTimeApproval(e, row.time)}
						/>
					) : (
						[
							row.time.approved ? (
								<span title="SI" key="1" className="bolita bolita-true" />
							) : (
								<span title="NO" key="2" className="bolita bolita-false" />
							),
						]
					),
			},
			{
				key: "actions",
				header: <FiMoreHorizontal />,
				sortable: false,
				headerClassName: "td-actions",
				className: "td-actions",
				render: (row) => this.getActionsCell(row.time, row.disabled),
			},
		];
	};

	desktopRowClassName = (row) => {
		const time = row.time;
		return [
			time.start !== null ? "filled" : "empty",
			row.isMain ? "main" : "repetida",
			row.isToday ? "today time-registrations-today-row" : "",
			row.disabled ? "disabled" : "",
			this.isTimeRegWeekBoundaryRow(time, row.index)
				? "time-reg-week-boundary"
				: "",
		]
			.filter(Boolean)
			.join(" ");
	};

	desktopRowKey = (row) => `${row.time.id}-${row.index}`;

	render() {
		return (
			<>
				<Layout className="page-time-registrations" context="times">
					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	const r = {
		...reducers.timesReducer,
		...reducers.employeesReducer,
		...reducers.ubicationsReducer,
		user: reducers.authReducer.user,
	};
	return r;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getEmployee: (id) => dispatch(employeesActions.getEmployee(id)),
	getSelectableTimeTypes: () => dispatch(timesActions.getSelectableTimeTypes()),
	getDefaultTimeType: () => dispatch(timesActions.getDefaultTimeType()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TimeRegistrations));
